import axios from 'axios';
import { addProspect } from '../AddProspect/AddProspect';

export const FindProspectURL = (
    url,
    setShowSearching, 
    setProfile,
    auth,
    fbProfile,
    setFoundInts,
    setInterests,
    setDocId,
    setContentGen,
    setError,
    setEmail
) =>{
    let data= { input: url }
    setEmail('')
    axios
        .post("https://boundapiv2.herokuapp.com/LIprofile", data, {
            headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
            }
        }
        )
        .then((response) => {
            if(response.data.name === "Error"){
                setShowSearching(false)
                setError("Oops something went wrong, we probably couldn't find their url, try searching again or create a personalized message by clicking below.")
                // console.log(error)
            } else {
            // setArticles(response.data.articles)
            setProfile(response.data)
                // console.log('profile', response.data)
            //function
            handleInterests(
                response.data, 
                url,
                setShowSearching, 
                auth,
                fbProfile,
                setFoundInts,
                setInterests,
                setDocId,
                setContentGen,
                )
            }
        }, (error) => {
            setShowSearching(false)
            setError("Oops something went wrong, we probably couldn't find their url, try searching again or create a personalized message by clicking below.")
            console.log(error)
        })       
}

const handleInterests = (
    profile, 
    url,
    setShowSearching, 
    auth,
    fbProfile,
    setFoundInts,
    setInterests,
    setDocId,
    setContentGen,
    ) =>{
    let major = ['']
    let summary = ''
    //console.log(profile)

    if(profile.education.length > 0){
        profile.education.map(edu =>{
            let arr = []
            major = arr
            return(
                arr.push(edu.field_of_study)
            )
        })
    }

    if(profile.summary !== ''){
        summary = profile.summary
    }

    major.join(' ')
    let inputText = `${summary} ${major}.`
    let content = inputText.replace(/\n/g, "")
    setFoundInts(content)

    //function
    getInterests(
        content, 
        profile, 
        url,
        setShowSearching, 
        auth,
        fbProfile,
        setInterests,
        setDocId,
        setContentGen,
        )
}

const getInterests = (
    content, 
    profile, 
    url,
    setShowSearching, 
    auth,
    fbProfile,
    setInterests,
    setDocId,
    setContentGen,
    ) =>{
    const message= { Input: content };

    // If content.length is less than....etc. then don't send to get analyzed
    var sendArr = []
    // const checkedArr = []


    if(content?.length > 60){
        // console.log('has summary')
        axios
        .post('https://boundapiv2.herokuapp.com/LIinterests', message)
        .then((response) => {

        let str = response.data

        str = str.substring(str.indexOf("1") - 2)
        let arr = str.split("\n")
            
        for(let i = 0; i < arr.length; i++){
            let int = arr[i].substring(3)
            if (int !== 'null' && int !== "" && int !== 'null ' && int !== ' null'){
                sendArr.push(int)
            }
        }
        checkExpDate(profile, sendArr)
        setInterests(sendArr)
        //function import
        addProspect(
            fbProfile, 
            profile, 
            url, 
            sendArr,  
            auth, 
            content, 
            setShowSearching, 
            setDocId,
            )

        setContentGen('')
        // here we will have to figure out if if we can send each interest to be classified and then any classified as work don't get sent 
    }, (error) => {
    console.log(error);
    sendArr = ''
        checkExpDate(profile, sendArr)
        //setInterests(sendArr)
        //function import
        addProspect(
            fbProfile, 
            profile, 
            url, 
            sendArr,  
            auth, 
            content, 
            setShowSearching, 
            setDocId,
            )

        setContentGen('')
    })
    // .then(() =>{

        // var function1 = () =>{
        
        //     var index = 0

        //     var checkedArr = []

        //     //  this is the for loop we need to wait for before moving to other function
        //     function getArray(){
        //         if (index < sendArr.length){
        //             let data = { Input: sendArr[index] }
        //             axios.post('https://boundapiv2.herokuapp.com/getIntClassified', data)
        //             .then((res) =>{
        //                 if(res.data === "Hobby"){
        //                     checkedArr.push(sendArr[index])
        //                     index = index + 1
        //                     getArray()
        //                 } else {
        //                     index = index + 1
        //                     getArray()
        //                 }
        //             }, (error) => {
        //                 checkExpDate(profile, checkedArr)
        //                 //setInterests(sendArr)
        //                 //function import
        //                 addProspect(
        //                 fbProfile, 
        //                 profile, 
        //                 url, 
        //                 checkedArr,  
        //                 auth, 
        //                 content, 
        //                 setShowSearching, 
        //                 setDocId,
        //                 )
            
        //                 setContentGen('')
        //                 console.log(error)
        //             })
        //         } else {
        //             checkExpDate(profile, checkedArr)
        //             //setInterests(sendArr)
        //             //function import
        //             addProspect(
        //                 fbProfile, 
        //                 profile, 
        //                 url, 
        //                 checkedArr,  
        //                 auth, 
        //                 content, 
        //                 setShowSearching, 
        //                 setDocId,
        //                 )
            
        //             setContentGen('')
        //         }

        //     } 
        //     getArray()
        // }

        // getting function
        // function1()

    // })
    } else {
        // console.log('no summary')
        sendArr = ''
        checkExpDate(profile, sendArr)
        //setInterests(sendArr)
        //function import
        addProspect(
            fbProfile, 
            profile, 
            url, 
            sendArr,  
            auth, 
            content, 
            setShowSearching, 
            setDocId,
            )

        setContentGen('')
    }

    function checkExpDate(contact, sendArr){
        if(contact.experiences.length > 0){
            var dateToday = new Date();
            var startDate = new Date(contact?.experiences[0]?.starts_at?.year, (contact?.experiences[0]?.starts_at?.month - 1), contact?.experiences[0]?.starts_at?.day)
            const diffTime = Math.abs(dateToday - startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
            if(diffDays <= 60){
                // console.log(sendArr)
                var arrInt = sendArr
                var arrAdd =['Just started a new role']

                if(sendArr === ''){
                    setInterests(arrAdd)
                } else {
                    // setInterests(arrInt?.unshift(arrAdd))
                    setInterests(arrInt.concat(arrAdd).reverse())
                }
            }else{
                setInterests(sendArr)
            }
        }else{
            setInterests(sendArr)
        }
    }
}
